import React from 'react';
import SectionTitle2 from '../../sectionTitle/SectionTitle2';
import { Element } from 'react-scroll';
import { Link } from 'react-router-dom';

const CaseStudy = () => {
  const outcome1 = "22%";
  const outcome2 = "92%";
  const outcome3 = "5 Hours";
  const outcome4 = "✓";

  return (
    <>
      <Element
        name="CaseStudy"
        className="datatalent-section-gap mea-key-features"
      >
        <div className="container inner about-feature-list">
          <div className="row g-5">
            <div className="col-12 mt-0 px-0 px-md-4">
              <SectionTitle2
                classes = "text-center"
                title = "Case Study"
              />
            </div>
            <div className="col-12 mt-4 px-0 px-md-4">
              {/* <p className="text-center">How we helped a precision manufacturing company embrace Industry 4.0.</p> */}
            </div>
            <div className="single-case-study-card d-flex flex-column flex-md-row align-items-center justify-content-between bg-white p-4 p-md-5">
              <div className="col-12 col-md-8">
                <div className="d-flex flex-row align-items-center justify-content-start gap-4">
                  <div className="icon-image-box h-100">
                    <img src={`${process.env.PUBLIC_URL}/images/icons/factory.svg`} alt="factory" />
                  </div>
                  <div className="title-and-subtitle">
                    <h5 className="mb-0 lh-1">Skyline Innovation</h5>
                    <p className="mb-0">Real-Time Speech Correction Platform for Skyline Innovation</p>
                  </div>
                </div>
                <h6 className="mt-5 mb-4">The Challenge</h6>
                <p>Speech accessibility for users with dysarthria (slurred or distorted speech) remains under-supported by traditional ASR (Automatic Speech Recognition) tools.</p>
                <h6 className="mb-4">Our Approach</h6>
                <p className="mb-0">M2M Tech helped Skyline Innovation benchmark 15 ASR models (Whisper, Parakeet, Canary, etc.), and deploy scalable cloud APIs. Key enhancements included autocorrection logic, confidence filtering, and text normalization.</p>
                <h6 className="mt-5 mb-4">Key Results</h6>
                <ul>
                  <li>22% reduction in Word Error Rate (WER)</li>
                  <li>85-92% live transcription confidence via cloud deployment</li>
                  <li>Cloud scalability expanded from 1-minute to 5-hour speech processing</li>
                  <li>Foundation built for real-time speech-to-text correction</li>
                </ul>
                <h6 className="mb-4">Impact</h6>
                <p className="mb-0">Skyline is poised to release one of the few real-time, AI-powered dysarthria-friendly transcription platforms, addressing a critical accessibility gap in healthcare and education.</p>
              </div>
              <div className="col-12 col-md-4 mt-4 md-mt-0">
                <div className="single-case-study-stats ms-md-4 p-4 p-md-5">
                  <h6>Key Outcomes</h6>
                  <div className="d-flex flex-row align-items-center justify-content-between">
                    <small>Reduction in Word Error Rate (WER)</small>
                    <small>{outcome1}</small>
                  </div>
                  <div className="case-study-progress-bar">
                    <div className="reduced-downtime-progress" style={{width: outcome1}}></div>
                  </div>
                  <div className="d-flex flex-row align-items-center justify-content-between mt-3">
                    <small>Live Transcription Confidence via Cloud</small>
                    <small>{outcome2}</small>
                  </div>
                  <div className="case-study-progress-bar">
                    <div className="quality-improvement-progress" style={{width: outcome2}}></div>
                  </div>
                  <div className="d-flex flex-row align-items-center justify-content-between mt-3">
                    <small>5-Hour Continuous Speech Analysis</small>
                    <small>{outcome3}</small>
                  </div>
                  <div className="case-study-progress-bar">
                    <div className="oee-increase-progress" style={{width: outcome3}}></div>
                  </div>
                  <div className="d-flex flex-row align-items-center justify-content-between mt-3">
                    <small>Real-Time Speech-to-Text Correction Foundation</small>
                    <small>{outcome4}</small>
                  </div>
                  <div className="case-study-progress-bar">
                    <div className="roi-timeline-progress" style={{width: outcome4}}></div>
                  </div>
                    <Link className="edu-btn btn-primary btn-small w-100 text-center mt-5" to="/contact-us">Request Full Case Study</Link>
                  </div>
              </div>
            </div>
          </div>
        </div>
      </Element>
    </>
  )
}

export default CaseStudy;